'use client';

import { c as _c } from "react/compiler-runtime";
import { CardSlider, CardSliderList, CardSliderListItem } from '@7f-ui/components/card-slider/card-slider';
import { Skeleton } from '@7f-ui/components/skeleton/skeleton';
type AppExperienceTimeslotsSkeletonProps = {
  cardCount?: number;
  isWalletFirst?: boolean;
};
export function AppExperienceTimeslotsSkeleton(t0) {
  const $ = _c(15);
  const {
    cardCount: t1,
    isWalletFirst: t2
  } = t0;
  const cardCount = t1 === undefined ? 3 : t1;
  const isWalletFirst = t2 === undefined ? false : t2;
  const visibleCardCount = Math.max(cardCount, 3);
  let t3;
  if ($[0] !== visibleCardCount) {
    t3 = Array.from({
      length: visibleCardCount
    }, _temp);
    $[0] = visibleCardCount;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const cardKeys = t3;
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Skeleton className="h-8 w-40 sm:w-52" />;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="pointer-events-auto flex items-center justify-between">{t4}<div className="hidden items-center gap-2 sm:flex"><Skeleton variant="circle" className="size-10" /><Skeleton variant="circle" className="size-10" /></div></div>;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  let t6;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div className="flex gap-2 sm:hidden"><Skeleton className="h-9 w-28 rounded-xl" /><Skeleton className="h-9 w-24 rounded-xl" /><Skeleton className="h-9 w-32 rounded-xl" /></div>;
    $[4] = t6;
  } else {
    t6 = $[4];
  }
  let t7;
  if ($[5] !== cardKeys) {
    t7 = cardKeys.map(_temp2);
    $[5] = cardKeys;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  let t8;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <CardSliderListItem className="relative grid-cols-3"><div className="flex h-full min-h-28 w-55 items-center gap-2 rounded-2xl border border-primary-green/15 bg-white p-6"><Skeleton className="h-4 w-24" /><Skeleton variant="circle" className="size-4" /></div></CardSliderListItem>;
    $[7] = t8;
  } else {
    t8 = $[7];
  }
  let t9;
  if ($[8] !== t7) {
    t9 = <div className="bleed-container xs:-mr-6 sm:-mr-0"><CardSlider fullBleed={true}>{t5}{t6}<CardSliderList className="w-full pr-1" isSlidable={true}>{t7}{t8}</CardSliderList></CardSlider></div>;
    $[8] = t7;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  let t10;
  if ($[10] !== isWalletFirst) {
    t10 = isWalletFirst ? <div className="flex h-6 items-center gap-3"><div className="flex gap-2"><Skeleton className="h-6 w-9" /><Skeleton className="h-6 w-9" /></div><Skeleton className="h-4 w-32" /><Skeleton variant="circle" className="size-5" /></div> : <ul className="flex flex-col gap-3"><li className="flex items-center gap-4"><Skeleton className="h-6 w-9" /><Skeleton className="h-4 w-40" /></li><li className="flex items-center gap-4"><Skeleton className="h-6 w-9" /><Skeleton className="h-4 w-48" /></li></ul>;
    $[10] = isWalletFirst;
    $[11] = t10;
  } else {
    t10 = $[11];
  }
  let t11;
  if ($[12] !== t10 || $[13] !== t9) {
    t11 = <div className="flex flex-col gap-6">{t9}{t10}</div>;
    $[12] = t10;
    $[13] = t9;
    $[14] = t11;
  } else {
    t11 = $[14];
  }
  return t11;
}
function _temp2(cardKey) {
  return <CardSliderListItem key={cardKey} className="relative grid-cols-3"><div className="flex w-55 flex-col items-start gap-2 rounded-2xl border border-primary-green/15 bg-white p-4"><Skeleton className="h-5 w-8/12" /><Skeleton className="h-4 w-10/12" /><Skeleton className="h-4 w-6/12" /></div></CardSliderListItem>;
}
function _temp(_, itemNumber) {
  return `timeslot-skeleton-${itemNumber + 1}`;
}